import React from "react"
import { Link } from "react-router"
import { prefixLink } from "gatsby-helpers"
import Helmet from "react-helmet"
import { config } from "config"
import { rhythm } from "../utils/typography"
import SideBar from "../components/SideBar"

import '../css/styles.css'

module.exports = React.createClass({
  propTypes() {
    return {
      children: React.PropTypes.any,
    }
  },
  render() {
    const pathname = this.props.location.pathname.replace(/\//g, '')
    return (
      <div>
        <Helmet
          title={config.siteTitle}
          meta={[
            { name: "description", content: "Sample" },
            { name: "keywords", content: "sample, something" },
          ]}
        />
        <div
          style={{
            background: '#8897A3',
            maxWidth: 900,
            paddingTop: 25,
            paddingBottom: 25,
            paddingLeft: 50,
            marginTop: 8,
            marginLeft: 8
          }}
        >
          <div
          >
            <h1 style={{ margin: 0 }}>
              <Link
                to={prefixLink("/")}
                style={{
                  color: "#000",
                  textDecoration: "none",
                }}
              >
              LAWRENCE PERLMAN <span>PHOTOGRAPHY</span>
              </Link>
            </h1>
          </div>
        </div>
        <div
          style={{
            background: '#8897A3',
            height: 690,
            marginLeft: 8,
            width: 900
          }}
        >
          <SideBar pathname={pathname}/>
          <div
            style={{
              maxWidth: 900,
              height: 690,
              background: '#8897A3',
              float: 'left',
              width: 716,
            }}
          >
            {this.props.children}
          </div>
        </div>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./_template.jsx